if (!customElements.get('creator-content-submission')) {
  customElements.define('creator-content-submission', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const form = this.querySelector('form');
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.sending || !form.reportValidity()) return;
        const success = form.querySelector('[data-success-message]');
        const error = form.querySelector('[data-error-message]');
        const button = form.querySelector('[type="submit"]');
        success.hidden = error.hidden = true;
        const endpoint = form.getAttribute('action')?.trim();
        if (!endpoint) {
          error.textContent = form.dataset.error;
          error.hidden = false;
          return;
        }
        this.sending = true;
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            body: new URLSearchParams(new FormData(form))
          });
          if (!response.ok || (await response.text()).trim() !== 'ok') throw new Error('Submission rejected');
          form.reset();
          success.textContent = form.dataset.success;
          success.hidden = false;
        } catch {
          error.textContent = form.dataset.error;
          error.hidden = false;
        } finally {
          this.sending = false;
          button.disabled = false;
          form.removeAttribute('aria-busy');
        }
      });
    }
  });
}
